/**
 * API endpoint constants.
 *
 * Centralizes all API URLs used across the application.
 * Previously scattered as globals in auth.js.
 *
 * Usage:
 *   import { postURL, shareholderURL } from './helpers/api-urls.js';
 */

export const urlBase = 'https://api.nthround.io/portal';

export const postURL = 'https://api.nthround.io/portal/user/update-user';
export const addminURL = 'https://api.nthround.io/portal/client/addmin';
export const shareholderURL = 'https://api.nthround.io/portal/client/shareholderData';
export const clientURL = 'https://api.nthround.io/portal/client/mainir';

export const cloudinaryURL = 'https://api.cloudinary.com/v1_1/nthround/auto/upload';
export const urlTransactions = 'https://api.nthround.io/portal/clientConfig/transactions';
export const authUploadUrl = 'https://api.nthround.io/portal/auth/get-upload-url';
export const authLinkUrl = 'https://api.nthround.io/portal/auth/get-new-authlink';
export const roomsURL = 'https://api.nthround.io/portal/rooms/rooms';
export const albumsAPI = 'https://api.nthround.io/portal/client/photo-album';
export const calendarAPI = 'https://api.nthround.io/portal/clientConfig/calendar-events';
export const customCapTableColumnsAPI = 'https://api.nthround.io/portal/clientConfig/cap-table-custom-columns';
export const capTableSummaryCardsAPI = 'https://api.nthround.io/portal/clientConfig/cap-table-summary-cards';
export const getCalendarAPI = 'https://api.nthround.io/portal/clientConfig/filtered-calendar-events';
export const lambdaStatusUrl = 'https://api.nthround.io/portal/user/lambda-status';
export const lambdaStatusDataUrl = 'https://api.nthround.io/portal/user/lambda-status-data';
export const getEncDataAPI = 'https://api.nthround.io/portal/user/get-enc-data';
export const putEncDataAPI = 'https://api.nthround.io/portal/user/put-enc-data';
export const getQBIntegrationStatusAPI = 'https://api.nthround.io/portal/integrations/get-integration-job-status';
export const qbInitCredsAPI = 'https://api.nthround.io/portal/integrations/quickbooks/init-creds';
export const qbTriggerDataSyncAPI = 'https://api.nthround.io/portal/integrations/quickbooks/trigger-data-sync';
export const dwollaTokenAPI = 'https://api.nthround.io/portal/auth/payment-processor-proxy';
export const urlEquityTransactionsScoped = 'https://api.nthround.io/portal/core-data/client/equity-transactions-scoped';
export const getVaultKeyAPI = 'https://api.nthround.io/portal/system/get-vault-key';
export const putVaultDataAPI = 'https://api.nthround.io/portal/system/put-vault-data';
export const getVaultDataAPI = `${urlBase}/system/wf/vault`;
/** @deprecated Prefer searchWorkflowsAPI + workflow payload for vault UI. */
export const getWorkflowConfigAPI = 'https://api.nthround.io/portal/system/wf/config';
/** Active workflows for a type; response should include configuration used to render vault fields. */
export const searchWorkflowsAPI = `${urlBase}/system/wf/executions/search`;
/** Initialize (and optionally start) a new workflow execution. POST body: { client, userid, cookie, workflow_type, workflow_name, input_data? }. Query param: start=true to also launch. */
export const initWorkflowAPI = `${urlBase}/system/wf/executions/init`;
/** Start a previously initialized workflow execution. POST body: { client, userid, cookie }. */
export const wfExecutionsStartURL = (executionId) => `${urlBase}/system/wf/executions/${executionId}/start`;
/** Advance a waiting workflow execution by one step. POST body: { client, userid, cookie, input_data }. */
export const wfExecutionsStepURL = (executionId) => `${urlBase}/system/wf/executions/${executionId}/step`;
/** Search pending/resolved approval requests. GET params: client, userid, cookie, execution_id?, status? */
export const wfApprovalsSearchURL = `${urlBase}/system/wf/approvals/search`;
/** Approve or reject a pending approval request. POST body: { approval_id, action, userid, client, cookie, rejection_reason? } */
export const wfApprovalsApproveURL = `${urlBase}/system/wf/approvals/approve`;
export const adminActivityFeedUrl = 'https://api.nthround.io/portal/auth/audit-trail-query';
